import { motion } from 'framer-motion';
import { AlertCircle, ChevronRight, ChevronDown, CheckCircle2, ArrowRight } from 'lucide-react';
import PortalShell from '@/components/PortalShell';

export default function ReportSubmittedScene() {
  return (
    <PortalShell activeItem="User" reportActive>
    <div data-testid="scene-report-submitted" className="flex flex-col items-center justify-start h-full px-8 pt-4 overflow-y-auto">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-5">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-emerald-100 text-emerald-700 mb-3">
            <CheckCircle2 size={14} /> Submitted
          </span>
          <h2 className="font-heading font-bold text-3xl tracking-tight text-[#0A0A0A]">Issue Reported</h2>
          <p className="mt-1.5 font-body text-sm text-[#737373]">Complaint submitted successfully</p>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}
          className="text-[12px] font-body text-[#737373] mb-4">
          Home <ChevronRight size={12} className="inline" /> <span className="font-medium text-[#0A0A0A]">Report Issue</span>
        </motion.div>

        {/* Success banner */}
        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="px-4 py-3 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center gap-3 mb-5"
        >
          <CheckCircle2 size={18} className="text-emerald-600 flex-shrink-0" />
          <p className="font-body text-sm text-emerald-800 font-medium">Your issue is being processed</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
          className="bg-white rounded-2xl border border-black/5 shadow-xl p-6 opacity-80">

          <h3 className="font-heading font-bold text-lg text-[#0A0A0A] mb-4">Basic details</h3>

          <div className="grid grid-cols-2 gap-x-5 gap-y-4 mb-3">
            <div>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Name</label>
              <div className="w-full px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A]">
                Abdul Ahmed
              </div>
            </div>
            <div>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Email address</label>
              <div className="w-full px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A]">
                abdulahmed@abc.com
              </div>
            </div>
          </div>

          <div className="mb-5">
            <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Module</label>
            <div className="w-1/2 px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A] flex items-center justify-between">
              <span>Mandatory Tariff</span>
              <ChevronDown size={16} className="text-[#737373]" />
            </div>
          </div>

          <div className="border-t border-[#E5E7EB] my-4" />

          <h3 className="font-heading font-bold text-lg text-[#0A0A0A] mb-4">Complaint</h3>

          <div className="grid grid-cols-2 gap-x-5 gap-y-4 mb-4">
            <div>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Subject<span className="text-red-500">*</span></label>
              <div className="w-full px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A]">
                Report export timeout error
              </div>
            </div>
            <div>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">File</label>
              <div className="flex gap-2">
                <div className="flex-1 px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A]">
                  error_screenshot.pdf
                </div>
                <button className="px-4 py-2.5 rounded-lg border border-[#E5E7EB] text-sm font-body font-medium text-[#737373] bg-[#FAFAFA]">
                  Upload
                </button>
              </div>
            </div>
          </div>

          <div>
            <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Description<span className="text-red-500">*</span></label>
            <div className="w-full px-3 py-3 rounded-lg border border-[#E5E7EB] bg-[#FAFAFA] text-sm font-body text-[#0A0A0A] min-h-[80px] leading-relaxed">
              We are experiencing intermittent errors when generating reports in the Mandatory Tariff module. The export function returns a timeout error after 30 seconds. This affects all facility admin users in our organization.
            </div>
            <p className="text-[11px] font-body text-[#737373] mt-1">Max 1,000 characters</p>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }} className="flex justify-center mt-5 mb-6">
          <button className="flex items-center gap-2 px-8 py-3 rounded-xl bg-teal-600/50 text-white font-body font-bold text-sm cursor-default">
            Submit <ArrowRight size={16} />
          </button>
        </motion.div>
      </motion.div>
    </div>
    </PortalShell>
  );
}
